import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { finalize } from 'rxjs';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);
  const loader = isBrowser ? inject(NgxUiLoaderService) : null;
  const showLoader = isBrowser && req.method !== 'GET';

  if (showLoader && loader) {
    loader.start();
  }

  let userData: any = {};

  if (isBrowser) {
    try {
      const userInfo = localStorage.getItem('userData');
      if (userInfo) {
        userData = JSON.parse(userInfo);
      }
    } catch (error) {
      console.error('Error parsing userinfo from localStorage', error);
    }
  }

  const token = userData?.token;

  const authReq = token
    ? req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    })
    : req;

  return next(authReq).pipe(
    finalize(() => {
      if (showLoader && loader) {
        loader.stop();
      }
    })
  );
};
